import { useEffect, useRef, useState } from 'react';
export const useUserHasRecentlyGivenConsent = (consentPromptEnabled, isHoverActive) => {
  const [hasRecentlyGivenConsent, setHasRecentlyGivenConsent] = useState(false);
  const prev = useRef({
    consentPromptEnabled,
    isHoverActive
  });
  useEffect(() => {
    if (prev.current.consentPromptEnabled && !consentPromptEnabled && isHoverActive) {
      setHasRecentlyGivenConsent(true);
    } else if (prev.current.isHoverActive && !isHoverActive) {
      setHasRecentlyGivenConsent(false);
    }
    prev.current = {
      consentPromptEnabled,
      isHoverActive
    };
  }, [consentPromptEnabled, isHoverActive]);
  return hasRecentlyGivenConsent;
};